import type { IPropertyFact } from 'src/services/api/properties/types';

export type IStringPropertyFact = IPropertyFact & { value: string };
export type IBooleanPropertyFact = IPropertyFact & { value: boolean };

// what the facts API accepts as a value; facts of any other shape are read-only here
export type PropertyFactValue = string | boolean;

export const isStringPropertyFact = (fact: IPropertyFact): fact is IStringPropertyFact =>
    typeof fact.value === 'string';

export const isBooleanPropertyFact = (fact: IPropertyFact): fact is IBooleanPropertyFact =>
    typeof fact.value === 'boolean';
